import Gallery from 'blueimp-gallery/js/blueimp-gallery';

export default function () {
  if ( $('.article-gallery-container .gallery-links a').length > 0) {
    var gallery;

    Gallery(
      $('.article-gallery-container .gallery-links a'),
      {
        container: '#article-gallery-carousel',
        carousel: true,
        continuous: true,
        slideshowInterval: false,

        onopen: function () {
          gallery = this;
        },

        onslide: function (index, slide) {
          var text = this.list[index].getAttribute('data-description');
          var description = this.container.find('.description');
          if (description[0]) { description[0].textContent = text };
          var credits = this.list[index].getAttribute('data-credits');
          if (credits) {
            var creditsNode = this.container.find('.credits');
            if (creditsNode[0]) { creditsNode[0].textContent = credits };
          }
        }
      }
    );

    $('.slide').each(function() {
      var index = $(this).data('index');
      var $img = $(this).find('.slide-content');
      var link = gallery.list[index];
      var alt = link.getAttribute('data-alt') || link.getAttribute('data-description');
      $img.attr('alt', alt);
    });
  }

  if ( $('#links a').length > 0) {
    Gallery(
      $('#links a'),
      {
        container: '#blueimp-gallery-carousel',
        carousel: true,
        stretchImages: false,
        slideshowInterval: false,

        onslide: function (index, slide) {
          var text = this.list[index].getAttribute('description');
          var date = this.list[index].getAttribute('date');
          var alt = this.list[index].getAttribute('alt');

          var node = this.container.find('.description');

          node.empty();
          if (text && node[0]) {
            node[0].appendChild(document.createTextNode(text));
          }

          node = this.container.find('.date');
          node.empty();
          if (date && node[0]) {
            node[0].appendChild(document.createTextNode(date));
          }

          var link = this.list[index].getAttribute('link');
          $(slide).children().attr('href', link);
          $(".description").attr('href', link);
          $(".slide-content img").attr('alt', alt);
        }
      }
    );
  }

  if ($('.next').children().length === 0) {
    $('.next').append('<i class="fas fa-angle-right icon-angle-right"></i>');
  }
  if ($('.prev').children().length === 0) {
    $('.prev').append('<i class="fas fa-angle-left icon-angle-left"></i>');
  }
}
